import styled from "styled-components/macro";
import { CustomJsonEditor } from "./debuggerComponents/CustomJsonEditor";
import { useSelector } from "store/useSelector";

const StoreDisplayStyles = styled.div``;
export default function StoreDisplay() {
  const state = useSelector(state => state);
  return (
    <StoreDisplayStyles className="consoleDataWrapper">
      <CustomJsonEditor
        value={state as unknown as Record<string, unknown>}
        height={window.innerHeight - 128}
      />
    </StoreDisplayStyles>
  );
}
